import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  
  private scrollSubject = new Subject<string>();

  scrollEvent$ = this.scrollSubject.asObservable();

  triggerScroll(componentId: string) {
    this.scrollSubject.next(componentId);
  }
}
